import { render, staticRenderFns } from "./Tramites.vue?vue&type=template&id=4bfc80bb"
import script from "./Tramites.vue?vue&type=script&lang=ts"
export * from "./Tramites.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports